import {format} from "date-fns";
import {enUS} from "date-fns/locale";

export const transformSaleEventDate = (date) => {
    return format(date.isDate? date : new Date(date), 'dd MMM yy, HH:mm', { locale: enUS })
}